var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseActions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E6ECF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3635 6.54539L6.54545 16.3635C6.24421 16.6647 6.2442 17.1531 6.54545 17.4544C6.84669 17.7556 7.3351 17.7556 7.63634 17.4544L17.4544 7.63629C17.7556 7.33504 17.7556 6.84663 17.4544 6.54539C17.1531 6.24415 16.6647 6.24415 16.3635 6.54539Z",
    fill: "#51566D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4553 16.3635L7.63724 6.54545C7.336 6.24421 6.84759 6.24421 6.54635 6.54545C6.24511 6.84669 6.24511 7.33511 6.54635 7.63635L16.3644 17.4544C16.6656 17.7557 17.1541 17.7557 17.4553 17.4544C17.7565 17.1532 17.7565 16.6648 17.4553 16.3635Z",
    fill: "#51566D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseActions);
export default __webpack_public_path__ + "static/media/closeActions.036c236068ce57a6d1158af693096fbc.svg";
export { ForwardRef as ReactComponent };